<template>
    <div class="hidden lg:block mb-28">
        <!-- Carrossel para Desktop -->
        <div class="flex gap-2">
            <button @click="prevSlide" class="flex-[1] mt-10 flex items-center justify-center">
                <img :src="require('@/assets/img/back-carousel.svg')" alt="" />
            </button>


            <div class="relative overflow-hidden flex-[12]">
                <!-- Slides -->
                <div class="flex transition-transform duration-500 ease-in-out"
                    :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
                    <div v-for="(product, index) in products" :key="index" class="w-1/3 flex-shrink-0">
                        <img :src="product?.images[0]?.src" alt="Product Image" class="w-full h-auto object-contain" />
                        <div class="text-center" v-html="product.name"></div>
                    </div>
                </div>
            </div>

            <!-- Dots -->
            <div class="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
                <span v-for="(dot, index) in totalSlides" :key="index" @click="goToSlide(index)"
                    class="w-3 h-3 rounded-full cursor-pointer" :class="{
                        'bg-deliRed': index === currentIndex,
                        'bg-deliLightCoral': index !== currentIndex,
                    }"></span>
            </div>

            <button @click="nextSlide" class="flex-[1] mt-10 flex items-center justify-center">
                <img :src="require('@/assets/img/forward-carousel.svg')" alt="" />
            </button>
        </div>
    </div>

    <!-- Lista Simples para Mobile -->
    <div class="block lg:hidden px-4">
        <div v-for="(product, index) in products" :key="index" class="mb-4">
            <img :src="product?.images[0]?.src" alt="Product Image" class="w-full h-auto object-cover" />
            <div class="mt-2 text-center" v-html="product.name"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            currentIndex: 0,
            itemsPerSlide: 3, // Número de itens visíveis por vez
        };
    },
    computed: {
        totalSlides() {
            // Número total de conjuntos de 3 produtos
            return Math.ceil(this.products.length / this.itemsPerSlide);
        },
    },
    methods: {
        nextSlide() {
            // Avança para o próximo conjunto
            this.currentIndex =
                (this.currentIndex + 1) % this.totalSlides;
        },
        prevSlide() {
            // Retorna ao conjunto anterior
            this.currentIndex =
                (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
        },
        goToSlide(index) {
            // Navega para um conjunto específico
            this.currentIndex = index;
        },
    },
};
</script>
